/**
 * Helpers for marketplace badge labels.
 */

/**
 * Returns the user-facing label for a paid-promotion listing badge.
 *
 * Both web and native platforms use "Spotlight" — this is the canonical
 * brand term. The helper is kept rather than inlined to provide a single
 * source of truth and a clean refactor point if behavior diverges later.
 */
export function getSpotlightLabel(): string {
  return 'Spotlight';
}
